<template>
  <bb-box
    thin
    class="d-flex flex-column align-items-start f-smallest m-x-30 m-b-30 limit-box"
  >
    <span
      class="f-gotham-bold uppercase f-color-gray p-b-5"
      v-sanitize.basic="header"
    />
    <slot />
  </bb-box>
</template>

<script>
export default {
  name: 'menu-notification-item',
  props: {
    header: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .limit-box {
    line-height: 1.3
  }
</style>
